<template>
  <select
    :id="id"
    class="widget-native-select premium-select"
    :value="stringValue"
    :disabled="disabled"
    @change="handleChange"
  >
    <option value="" disabled>{{ placeholder }}</option>
    <option v-for="option in options" :key="String(option.value)" :value="String(option.value)">
      {{ option.label }}
    </option>
  </select>
</template>

<script setup lang="ts">
import { computed } from 'vue';

export interface NativeSelectOption {
  value: string | number;
  label: string;
}

interface Props {
  modelValue: string | number | null | undefined;
  options: NativeSelectOption[];
  placeholder: string;
  id?: string;
  disabled?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  id: undefined,
  disabled: false,
});

const emit = defineEmits<{
  'update:modelValue': [value: string];
}>();

const stringValue = computed(() => {
  if (props.modelValue === null || props.modelValue === undefined || props.modelValue === '') {
    return '';
  }
  return String(props.modelValue);
});

const handleChange = (event: Event): void => {
  emit('update:modelValue', (event.target as HTMLSelectElement).value);
};
</script>

<style scoped>
.widget-native-select {
  width: 100%;
  min-height: 48px;
  padding: 0 40px 0 16px;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  background-color: #f8fafc;
  color: var(--ui-strong);
  font-size: 15px;
  font-weight: 500;
  font-family: inherit;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%2364748b' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 14px center;
  transition: border-color 0.3s ease, background-color 0.3s ease;
}

.widget-native-select:focus {
  outline: none;
  border-color: var(--ui-accent);
  background-color: #ffffff;
  box-shadow: 0 0 0 4px var(--ui-accent-soft);
}

.widget-native-select:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.widget-native-select:invalid {
  color: var(--ui-muted);
}
</style>
